'use strict';

(function () {
	ReactTemplates.INPUTS.upCountry = window.UpCountry;
})();
